import { PerspectiveCamera, Vector3 } from 'three'
import { useEffect, useState } from 'react'
import { useAppStore } from '../../shared/store/store'

export function useCamera(startCameraPosition: Vector3): PerspectiveCamera {
  const [camera] = useState(new PerspectiveCamera(30, 1, 0.1, 2000))
  const width = useAppStore((state) => state.width)
  const height = useAppStore((state) => state.height)

  useEffect(() => {
    camera.position.copy(startCameraPosition)
  }, [])

  useEffect(() => {
    camera.aspect = width / height
    camera.updateProjectionMatrix()
  }, [width, height])

  return camera
}
